<template>
    <div>
        <el-dropdown @command="handleClick">
            <K2Button size="mini" style="height: 100%; margin-left:10px;" :background="uiVariable.color.secondary">
                <i class="material-icons">history</i>
            </K2Button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in dropdownList" :command="item">{{item}}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>

</template>
<script>

  import K2Button from "../k2Button/k2Button";
  import uiVariable from "../../config/uiVariable";

  export default {
    name: "K2Dropdown",
    components: { K2Button },
    props: ["dropdownList", "change"],
    data: function() {
      return {
        uiVariable: uiVariable,
        content: this.value
      };
    },
    methods: {
      handleClick(command) {
        this.$emit("change", command);
      }
    }
  };
</script>
<style>
    textarea {
        width: 100%;
        border-color: #DCDFE6;
        padding: 5px 10px;
        border-radius: 3px;
        color: #536170;
    }
</style>
